/*
 * Contents Messages
 *
 * This contains all the text for the Contents component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'CONTENTS.title',
    defaultMessage: 'Contents',
  },
  linkTitle: {
    id: 'CONTENTS.link_title',
    defaultMessage: 'Go to relevant section',
  },
});



// WEBPACK FOOTER //
// ./components/molecules/TranscriptContents/messages.js